<template>
  <div class="v-header">
    <div class="v-header-logo">
      <img :src="webSetting.manager_logo" alt />
    </div>
    <div class="header-wrap">
      <!-- <div
        class="header-item"
        @click="setNavList({menu_url:'Home'})"
        :class="{'active':$store.state.currentModule=='Home'}"
      >
        <i class="ivu-icon"></i>
        首页
      </div>-->
      <div
        class="header-item"
        @click="setNavList(item)"
        :key="index"
        v-for="(item,index) in menus"
        :class="{'active':item.menu_url==$store.state.currentModule}"
      >
        <i class="nav-icon" :class="item.menu_icon"></i>
        {{item.title}}
      </div>
    </div>
    <div class="tool-bar" v-if="userInfo">
      <ul style="float:right" class="bar-list">
        <li v-click-outside="closeDialog">
          <Avatar
            style="cursor:pointer"
            :src="userInfo.avatar"
            @click.native="infoBlock = !infoBlock"
            class="avatar-icon"
            icon="ios-person"
          />
          <Icon
            color="#fff"
            @click.native="infoBlock = !infoBlock"
            size="30"
            type="md-arrow-dropdown"
          />
          <transition name="name">
            <div v-show="infoBlock" class="tdui-user-body" id="userinfo">
              <div class="tdui-user-body-list tdui-user-body-list-first">
                <div class="tdui-user-body-list-start">
                  <Avatar :src="userInfo.avatar" color="#fff" icon="ios-person" />
                </div>
                <div
                  name="user-login-email"
                  class="tdui-user-body-list-first-end"
                >{{userInfo.nickname}}</div>
              </div>
              <div @click="account" class="tdui-user-body-list">
                <div class="tdui-user-body-list-start">
                  <Icon color="#aaa" size="20" type="md-settings" />
                </div>
                <div class="tdui-user-body-list-end" name="account-setting">账号设置</div>
              </div>
              <div @click="loginOut" class="tdui-user-body-list">
                <div class="tdui-user-body-list-start">
                  <Icon color="#aaa" size="20" type="ios-log-out" />
                </div>
                <div class="tdui-user-body-list-end" name="account-exit">退出登录</div>
              </div>
            </div>
          </transition>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      infoBlock: false,
      webSetting: {}
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.user;
    },
    menus() {
      return this.$store.state.menus;
    }
  },
  async activated() {
    let data = await this.$http.post("/api/menu/info");
    let menus = data.rows;
    this.$store.commit("setMenus", {
      menus,
      routes: this.$router.options.routes
    });
    let route = this.$route.matched[1];
    let currentModule;
    let item;
    if (route) {
      currentModule = route.name;
      item = menus.filter(m => m.menu_url == currentModule)[0];
    }
    if (item) {
      this.$store.commit("setCurrentModule", currentModule);
      this.setNavList(item, {
        name: this.$route.name,
        query: this.$route.query,
        params: this.$route.params
      });
    } else {
      if (menus.length > 0) {
        item = menus[0];
        currentModule = item.menu_url;
        this.setNavList(item);
      } else {
        this.$store.commit("setLeftMenus", []);
      }
    }

    this.webSetting = await this.$http.get("/api/webSetting");

    let link =
      document.querySelector("link[rel*='icon']") ||
      document.createElement("link");
    link.type = "image/x-icon";
    link.rel = "shortcut icon";
    link.href = this.webSetting.web_ico;
    document.getElementsByTagName("head")[0].appendChild(link);
  },
  async mounted() {},
  watch: {
    // 处理回退历史记录 子级页面直接切换tab点击浏览器返回按钮导致的tab无法切换
    $route(val) {
      if (val.matched.length <= 1) {
        return;
      }
      if (val.matched[1].name != this.$store.state.currentModule) {
        for (let i in this.menus) {
          if (this.menus[i].menu_url == val.matched[1].name) {
            let item = this.menus[i];
            if (!this.$store.state.openName) {
              this.$store.commit("setOpenName", item.children[0].menu_url);
            }
            this.$store.commit("setCurrentModule", item.menu_url);
            this.$store.commit("setLeftMenus", item.children);
            break;
          }
        }
      }
    }
  },
  methods: {
    account() {
      let settingMenu = this.menus.filter(m => m.menu_url == "Setting")[0];
      if (settingMenu) {
        this.setNavList(settingMenu, "SettingAccountNew");
      }
      this.infoBlock = false;
    },
    async loginOut() {
      this.infoBlock = false;
      await this.$promiseConfirm("确定退出登录吗？");
      this.$store.commit("logout");
      this.$router.push({
        name: "Login"
      });
    },
    ready() {
      document.addEventListener("click", e => {
        if (!this.$el.contains(e.target)) this.infoBlock = false;
      });
    },
    closeDialog() {
      this.infoBlock = false;
    },
    setNavList(item, openUrl) {
      this.$store.commit("setCurrentModule", item.menu_url);
      if (item.menu_url == "Main" || item.menu_url == "Home") {
        this.$router.push({
          name: item.menu_url
        });
        return;
      }
      if (item.children.length == 0) {
        return;
      }
      let child = item.children[0];
      if (!this.$store.state.openName) {
        this.$store.commit("setOpenName", child.menu_url);
      }
      let url;
      if (openUrl) {
        url = openUrl;
      } else {
        if (child.children) {
          url = child.children[0].menu_url;
        } else {
          url = child.menu_url;
        }
      }
      if (typeof url == "string") {
        this.$router.push({
          name: url
        });
      } else {
        this.$router.push(url);
      }
      this.$store.commit("setLeftMenus", item.children);
    }
  },
  directives: {
    clickOutside: {
      bind(el, binding) {
        function clickHandler(e) {
          if (el.contains(e.target)) {
            return false;
          }
          if (binding.expression) {
            binding.value(e);
          }
        }
        el.__vueClickOutside__ = clickHandler;
        document.addEventListener("click", clickHandler);
      },
      update() {},
      unbind(el) {
        document.removeEventListener("click", el.__vueClickOutside__);
        delete el.__vueClickOutside__;
      }
    }
  }
};
</script>

<style lang="scss">
.v-header {
  min-width: 1220px;
  .v-header-logo {
    height: 64px;
    width: 170px;
    float: left;
    text-align: center;
    img {
      display: inline-block;
      height: 40px;
      vertical-align: middle;
    }
  }
  background-color: #2b83f9;
  background-image: linear-gradient(143deg, #2945cb 20%, #2b83f9 81%, #3a9dff);
  .header-wrap {
    padding: 0 20px;
    display: inline-block;
    height: 100%;
    .header-item {
      display: inline-block;
      margin-right: 40px;
      position: relative;
      height: 64px;
      line-height: 64px;
      font-size: 14px;
      color: #fff;
      opacity: 0.69;
      cursor: pointer;
      transition: all 0.2s ease-in-out;
      i {
        display: inline-block;
        margin-right: 4px;
        vertical-align: middle;
      }
    }
    .header-item.active,
    .header-item:hover {
      color: #fff;
      opacity: 1;
    }
    .active::after {
      content: "";
      display: block;
      width: 100%;
      height: 4px;
      background-color: #4fe3c1;
      position: absolute;
      bottom: 0;
      left: 0;
    }
  }
  .tool-bar {
    float: right;
    .bar-list {
      line-height: 64px;
      display: inline-block;
      li {
        float: left;
        list-style-type: none;
        padding: 0 13px;
        position: relative;
        & > i {
          cursor: pointer;
          transition: all 0.3s ease-in;
          &:hover {
            transition: all 0.3s ease-out;
          }
        }
      }
    }
  }
}
.tdui-user-body {
  position: absolute;
  width: 240px;
  top: 70px;
  right: 5px;
  background: #ffffff;
  box-shadow: 0 4px 24px -1px rgba(0, 0, 0, 0.25);
  border-radius: 4px;
  z-index: 99999999;
  .tdui-user-body-list {
    height: 48px;
    display: flex;
    line-height: 48px;
    cursor: pointer;
    &:hover {
      background-color: #f1f1f1;
    }
    .tdui-user-body-list-start {
      width: 68px;
      text-align: center;
    }
    .tdui-user-body-list-first-end {
      flex: 1;
      font-size: 14px;
      color: #2185f0;
      white-space: nowrap;
      overflow: hidden;
    }
  }
  .tdui-user-body-list-first {
    cursor: default;
    display: flex;
    height: 64px;
    line-height: 64px;
    border-bottom: solid 1px rgba(23, 35, 61, 0.1);
    &:hover {
      background-color: #fff;
    }
  }
}
.name-enter,
.name-leave-to {
  opacity: 0;
  // transform: scale(0)
}
// 定义离开前与进入后状态
.name-enter-to,
.name-leave {
  opacity: 1;
  // transform: scale(1);
}
// 定义进出过程
.name-enter-active,
.name-leave-active {
  transition: all 0.3s;
}
.nav-icon {
  width: 14px;
  height: 14px;
  background-size: 100% 100%;
  &.user {
    background-image: url(../assets/images/header/user@3x.png);
  }
  &.teach {
    background-image: url(../assets/images/header/teach@3x.png);
  }
  &.market {
    background-image: url(../assets/images/header/market@3x.png);
  }
  &.finance {
    background-image: url(../assets/images/header/finance@3x.png);
  }
  &.operation {
    background-image: url(../assets/images/header/operation@3x.png);
  }
  &.statistics {
    background-image: url(../assets/images/header/statistics@3x.png);
  }
  &.setting {
    background-image: url(../assets/images/header/setting@3x.png);
  }
  &.book {
    background-image: url(../assets/images/header/book@3x.png);
  }
}
.header-item.active .nav-icon {
  &.user {
    background-image: url(../assets/images/header/user-selected@3x.png);
  }
  &.teach {
    background-image: url(../assets/images/header/teach-selected@3x.png);
  }
  &.market {
    background-image: url(../assets/images/header/market-selected@3x.png);
  }
  &.finance {
    background-image: url(../assets/images/header/finance-selected@3x.png);
  }
  &.operation {
    background-image: url(../assets/images/header/operation-selected@3x.png);
  }
  &.statistics {
    background-image: url(../assets/images/header/statistics-selected@3x.png);
  }
  &.setting {
    background-image: url(../assets/images/header/setting-selected@3x.png);
  }
  &.book {
    background-image: url(../assets/images/header/book-selected@3x.png);
  }
}
</style>
